import { useMsal } from "@azure/msal-react";

const useMsalApi = () => {
    const {instance, accounts} = useMsal();

    async function callApi(path, verb, params, contentType, isFile) {
        if(!window.env){
            await fetch('/settings.json',{
                headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                }
            })
            .then(response =>  response.json())
            .then((data) => {window.env = data;})
            .catch(error => console.log(error));
        }
        const request = {
            scopes: [window.env.apiScope],
            account: accounts[0],
        }
        var token;
        try {
            token =  (await instance.acquireTokenSilent(request)).accessToken;
        } catch {
            token = (await instance.acquireTokenPopup(request)).accessToken;
        }

        if(!window.language){
            window.language = 'en';
        }
        if(!contentType){
            contentType = "application/json";
            params = params ? JSON.stringify(params) : null
        }

        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append("Authorization", bearer);
        headers.append("Accept","*/*");
        if(contentType !== "multipart/form-data")
            headers.append("Content-Type", contentType);
        headers.append("Content-Language", window.language);


        

        const options = {
            method: verb,
            headers: headers,
            body: params
        };

        const response = await fetch(`${window.env.baseUrl}/${path}`, options).catch(error => {console.log(error); return error;});
        if (response.ok) {
            const contentType = response.headers.get('content-type');
            if (isFile === true)
                return await response.blob();
            if (contentType && contentType.indexOf('application/json') !== -1) {
                return await response.json();
            } else if(contentType && contentType.indexOf('text/plain') !== -1) {
                return await response.text();
            }
            return "";
        } else if(response.ok === false){
            let customMessage = "";
            switch(response.status){
                case 404:
                    customMessage = `404 Unable to find endpoint. ${window.env.baseUrl}/${path}`;
                    alert(customMessage);
                    break;
                case 409:
                    customMessage = `Already Enrolled.`;
                    break;
                case 500:
                    customMessage = (await response.json()).error;
                    alert(customMessage);
                    break;
                case 401:
                    customMessage = "Unauthorized";
                    alert(customMessage);
                    break;
                default:
                    customMessage = "Something went wrong";
                    alert(customMessage);
                    break;

            }
            const responseError = {
                type: 'Error',
                message: response.message || customMessage,
                data: response.data || '',
                code: response.status || '',
            };   
            let error = new Error();
            error = { ...error, ...responseError };
            return {error: error};
        } else{
            return {error: response};
        } 

    }

    return [callApi];
}


export default useMsalApi;